import { useTranslation } from 'react-i18next';

import { SummaryInformation, TSummaryInformation } from '@/ui-kit/SummaryInformation/SummaryInformation';

import { IUser } from '@/features/user/store/user.model';
import { TPhysicalSectionKey } from '@/features/kyc/store/types/physical.types';
import { KycInformationSection } from '@/features/kyc/components/userInformation/InformationSection';
import { usePhysicalUserInformationProps } from '@/features/kyc/hooks/usePhysicalUserInformationProps';

interface IMainInformation {
  user: IUser;
  isSectionOnEdition: (key: TPhysicalSectionKey) => boolean;
  isSectionEditable: (key: TPhysicalSectionKey) => boolean;
  toogleSectionEditMode: (key: TPhysicalSectionKey) => void;
}

export function PhysicalMainInformation({
  user,
  isSectionOnEdition,
  isSectionEditable,
  toogleSectionEditMode,
}: IMainInformation) {
  const { t } = useTranslation();

  const isPersonalInformationOnEdition = isSectionOnEdition('personalInformation');
  const isAddressesOnEdition = isSectionOnEdition('address');
  const isContactOnEdition = isSectionOnEdition('contact');

  const {
    hierarchicalRelation,
    personalInformation,
    address,
    isLoading,
    isPersonalInformationInvalid,
    isAddressValid,
    isContactInvalid,
    contact,
    onUpdateUser,
    onCancelEdition,
  } = usePhysicalUserInformationProps({
    user,
    isPersonalInformationOnEdition,
    isAddressesOnEdition,
    isContactOnEdition,
  });

  const userInformation: TSummaryInformation = {
    title: t('pages.dashboard.createUser.form.pages.userInformation'),
    sections: [
      ...hierarchicalRelation,
      {
        component: (
          <KycInformationSection
            section={personalInformation}
            isOnEdition={isPersonalInformationOnEdition}
            sectionKey="personal-information"
            isLoading={isLoading}
            isFormInvalid={isPersonalInformationInvalid}
            isSectionNotEditable={isSectionEditable('personalInformation')}
            onEdit={() => toogleSectionEditMode('personalInformation')}
            onSave={() => onUpdateUser(() => toogleSectionEditMode('personalInformation'))}
            onCancel={() => onCancelEdition(() => toogleSectionEditMode('personalInformation'))}
          />
        ),
      },
      {
        component: (
          <KycInformationSection
            section={address}
            isOnEdition={isAddressesOnEdition}
            sectionKey="address"
            isLoading={isLoading}
            isFormInvalid={isAddressValid}
            isSectionNotEditable={isSectionEditable('address')}
            onEdit={() => toogleSectionEditMode('address')}
            onSave={() => onUpdateUser(() => toogleSectionEditMode('address'))}
            onCancel={() => onCancelEdition(() => toogleSectionEditMode('address'))}
          />
        ),
      },
      {
        component: (
          <KycInformationSection
            section={contact}
            isOnEdition={isContactOnEdition}
            sectionKey="contact"
            isLoading={isLoading}
            isFormInvalid={isContactInvalid}
            isSectionNotEditable={isSectionEditable('contact')}
            onEdit={() => toogleSectionEditMode('contact')}
            onSave={() => onUpdateUser(() => toogleSectionEditMode('contact'))}
            onCancel={() => onCancelEdition(() => toogleSectionEditMode('contact'))}
          />
        ),
      },
    ],
  };

  return <SummaryInformation {...userInformation} key="userInformation" />;
}
